const Config = {
    domain: 'https://report.vehiclesend.com',
    enckey: '26c81b3cb145f643e780bfb66a093e5465edc843406433d95c2b7db4ea6283ca',
    // ... any other global constants ...
  };
  
  export default Config;